import { BREAKPOINTS } from "@constants";
import styled from "styled-components";

export const Canvas = styled.div<{ centerContent?: boolean }>`
  align-items: ${({ centerContent }) => centerContent && "center"};
  background: ${({ theme }) => theme.background.sand};
  display: ${({ centerContent }) => centerContent && "flex"};
  grid-area: canvas;
  justify-content: ${({ centerContent }) => centerContent && "center"};

  ${BREAKPOINTS.small`
    grid-row: 1 / -1`}
`;
